export const AID_MODEL_STATUS_LABELS = {
  DRAFT: 'Draft',
  GENERATED: 'Generated',
  SHARED: 'Shared',
};

export const AID_MODEL_STATUS_STYLES = {
  DRAFT: 'bg-gray-200 text-gray-700',
  GENERATED: 'bg-green-100 text-green-700',
  SHARED: 'bg-blue-100 text-blue-700',
};

export const AID_STUDIO_STATUS_FORM_FIELDS = [
  {
    label: 'All',
    labelFor: 'all',
    radioValue: 'all',
    valueForEdit: 'All',
  },
  {
    label: 'Generated',
    labelFor: 'generated',
    radioValue: 'generated',
    valueForEdit: 'Generated',
  },
  {
    label: 'Not generated',
    labelFor: 'not-generated',
    radioValue: 'notGenerated',
    valueForEdit: 'Not generated',
  },
  {
    label: 'Not published',
    labelFor: 'not-published',
    radioValue: 'notPublished',
    valueForEdit: 'Not published',
  },
];

export const getStatusFilterValue = (
  filterOption: string
): string[] | undefined => {
  switch (filterOption) {
    case 'generated':
      return ['GENERATED'];
    case 'notGenerated':
      return ['DRAFT'];
    case 'notPublished':
      return ['DRAFT', 'GENERATED'];
    case 'all':
    default:
      return undefined;
  }
};
